
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[id]",
      function () {
        return require("private-next-pages/article/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/[id]"])
      });
    }
  